import type { IItemDataResponse } from '@/pages/PurchasesContainer/RequestPerHand/api/HandRequest.interface';

interface LastIncomingSectionProps {
  itemData: IItemDataResponse | null;
}

export const LastIncomingSection = ({ itemData }: LastIncomingSectionProps) => {
  if (!itemData?.itemLastIncomingBySupplier) {
    return (
      <div className="mt-2 flex items-center gap-2 rounded-md border border-yellow-200 bg-yellow-50 px-3 py-1.5 text-sm text-yellow-800 dark:border-yellow-800 dark:bg-yellow-950/30 dark:text-yellow-300">
        <span className="flex h-6 items-center rounded-md bg-yellow-200 px-2 font-bold text-yellow-900 dark:bg-yellow-800 dark:text-yellow-100">
          اخر توريد
        </span>
        <span className="rounded-md border border-yellow-200 bg-white px-2 py-0.5 dark:border-yellow-800 dark:bg-yellow-950/60 dark:text-yellow-100">
          لايوجد توريد
        </span>
      </div>
    );
  }

  return (
    <div className="mt-1 flex flex-wrap items-center gap-2 gap-x-3 overflow-x-auto rounded-md border border-blue-200 bg-blue-50 px-3 py-1.5 text-sm shadow-sm dark:border-blue-800 dark:bg-blue-950/30 dark:shadow-blue-900/20">
      <span className="flex h-6 shrink-0 items-center rounded-md bg-blue-500 px-2 font-bold text-white shadow-sm dark:bg-blue-600 dark:shadow-blue-900/30">
        اخر توريد
      </span>
      <div className="flex items-center gap-1.5">
        <span className="whitespace-nowrap text-xs font-medium text-blue-700 dark:text-blue-300">
          رقم :
        </span>
        <span className="whitespace-nowrap rounded-md border border-blue-200 bg-white px-2 py-0.5 font-medium text-blue-900 shadow-sm dark:border-blue-800 dark:bg-blue-900 dark:text-blue-100 dark:shadow-none">
          {itemData.itemLastIncomingBySupplier.ID}
        </span>
      </div>
      <div className="flex items-center gap-1.5">
        <span className="whitespace-nowrap text-xs font-medium text-blue-700 dark:text-blue-300">
          التاريخ:
        </span>
        <span className="whitespace-nowrap rounded-md border border-blue-200 bg-white px-2 py-0.5 font-medium text-blue-900 shadow-sm dark:border-blue-800 dark:bg-blue-900 dark:text-blue-100 dark:shadow-none">
          {new Date(
            itemData.itemLastIncomingBySupplier.TrDate,
          ).toLocaleDateString('en-US')}
        </span>
      </div>
      <div className="flex items-center gap-1.5">
        <span className="whitespace-nowrap text-xs font-medium text-blue-700 dark:text-blue-300">
          الكمية:
        </span>
        <span className="whitespace-nowrap rounded-md border border-blue-200 bg-white px-2 py-0.5 font-medium text-blue-900 shadow-sm dark:border-blue-800 dark:bg-blue-900 dark:text-blue-100 dark:shadow-none">
          {itemData.itemLastIncomingBySupplier.Qty}
        </span>
      </div>
      <div className="flex items-center gap-1.5">
        <span className="whitespace-nowrap text-xs font-medium text-blue-700 dark:text-blue-300">
          السعر:
        </span>
        <span className="whitespace-nowrap rounded-md border border-blue-200 bg-white px-2 py-0.5 font-medium text-blue-900 shadow-sm dark:border-blue-800 dark:bg-blue-900 dark:text-blue-100 dark:shadow-none">
          {itemData.itemLastIncomingBySupplier.UnitPrice}
        </span>
      </div>
      <div className="flex items-center gap-1.5">
        <span className="whitespace-nowrap text-xs font-medium text-blue-700 dark:text-blue-300">
          الخصم:
        </span>
        <span className="whitespace-nowrap rounded-md border border-blue-200 bg-white px-2 py-0.5 font-medium text-blue-900 shadow-sm dark:border-blue-800 dark:bg-blue-900 dark:text-blue-100 dark:shadow-none">
          {itemData.itemLastIncomingBySupplier.Discount}%
        </span>
      </div>
    </div>
  );
};
